import { Checkbox, FormLayout, LegacyCard } from '@shopify/polaris'
import { useFormikContext } from 'formik'

import { useFormikHandleChangeCallback } from '../common/helpers'
import { LegacyHelpIcon } from '../common/HelpIcon'
import { UserSettings } from './api'

export const ProductPageCard = () => {
  const formik = useFormikContext<UserSettings>()
  const handleChange = useFormikHandleChangeCallback(formik.setFieldValue)

  return (
    <LegacyCard>
      <LegacyCard.Section>
        <FormLayout>
          <Checkbox
            id="customers_can_add_products_from_widget"
            name="customers_can_add_products_from_widget"
            label={
              <span>
                Allow adding products to an existing subscription from the product page{' '}
                <LegacyHelpIcon>
                  This setting will add a button to the selling plan widget, allowing customers to
                  add products directly to an existing subscription. The button will only appear if
                  they have an active subscription matching at least one of the selling plans
                  assigned to the selected product variant.
                </LegacyHelpIcon>
              </span>
            }
            checked={formik.values.customers_can_add_products_from_widget}
            onChange={handleChange}
          />
        </FormLayout>
      </LegacyCard.Section>
    </LegacyCard>
  )
}
